import { Injectable, inject } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastService } from 'libs/core/toast/toast.service';
import {
  SKIP_GLOBAL_ERROR_HANDLER,
  SKIP_GLOBAL_401_REDIRECT,
  SKIP_GLOBAL_ERROR_TOAST
} from 'libs/core/http/http-context.tokens';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private router = inject(Router);
  private toast = inject(ToastService);

  //! Rep les peticions HTTP
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
    //? Intercepta errors HTTP i redirigeix segons l'error
  ): Observable<HttpEvent<unknown>> {
    // Header per si es vol saltar el toast d'error
    const skipAll = request.context.get(SKIP_GLOBAL_ERROR_HANDLER);
    const skip401Redirect = request.context.get(SKIP_GLOBAL_401_REDIRECT);
    const skipToast = request.context.get(SKIP_GLOBAL_ERROR_TOAST);

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
         // El component vol gestionar completament l’error
        if (skipAll) {
          return throwError(() => error);
        }

        if (error.status === 401 && !skip401Redirect) {
          // 401 unauthorized
          this.router.navigate(['/signin']);
        }

        // Mostrem el toast d'error (no si l'app és en background i la connexió s'ha tallat)
        const isBackgroundNetworkError = error.status === 0 && document.hidden;
        if (!skipToast && !isBackgroundNetworkError) this.toast.presentToast('error', 'Error', this.parseMessage(error), 'bottom');
        
        return throwError(() => error);
      })
    );
  }

  parseMessage(error: HttpErrorResponse): string {
    const backendMsg = typeof error.error === 'string'? error.error : error.error?.message ?? error.error?.detail;
    if (backendMsg) return backendMsg;
    
    // Si el backend no ha enviat missatge, posem un genèric segons codi d'error
    switch (error.status) {
      case 0: return 'No se ha podido conectar con el servidor. Revisa tu conexión e inténtalo de nuevo.';
      case 400: return 'Hay datos incorrectos o incompletos. Revísalos e inténtalo de nuevo.';
      case 401: return 'No tienes permisos para realizar esta acción.';
      case 403: return 'No tienes permisos para realizar esta acción.';
      case 404: return 'No se ha encontrado el recurso solicitado';
      case 500: return 'Ha ocurrido un problema en el servidor. Inténtalo de nuevo en unos minutos.';
      default: return 'No se ha podido completar la acción. Inténtalo de nuevo.';
    }
  }
}
